import React from 'react';
import R from 'ramda';

const Watermark = ({ texts }) => {
  const basicTextStyle = {
    color: 'rgba(211, 211, 211, 0.45)',
    fontSize: '100px',
    lineHeight: '100px',
    transform: 'rotate(30deg)',
    'WebkitTransform': 'rotate(30deg)',
    marginBottom: '250px',
  };
  return (
    <div style={{
      position: 'absolute',
      zIndex: '2',
      background: 'none',
      display: 'block',
      minHeight: '50%',
      minWidth: '40%',
    }}
    >
      {
        texts.map((text, i) => {
          if (i > 0) return <p style={R.merge(basicTextStyle, { marginLeft: `${40 + 60 * i}px` })} key={i}>{text}</p>;
          return <p style={R.merge(basicTextStyle, { marginTop: '160px' })} key={i}>{text}</p>;
        })
      }
    </div>
  );
};

export default Watermark;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/watermark.jsx